export default __webpack_public_path__ + "static/media/first.52c18bc3.gif";